import { gridSquare11Cls, gridSquare21Cls, gridSquare31Cls, gridSquare32Cls, gridSquare41Cls, gridSquare51Cls, gridSquare71Cls } from "./Grid.less";
var SETTINGS = {
  1: {
    styles: {
      1: {
        grid: {
          type: "flex",
          justify: "space-between",
          gutter: {
            sm: 24
          },
          className: gridSquare11Cls
        },
        col: {
          xs: 24,
          sm: 12,
          md: 24
        }
      }
    }
  },
  2: {
    styles: {
      1: {
        grid: {
          type: "flex",
          justify: "space-around",
          className: gridSquare21Cls
        },
        col: {
          xs: 24,
          sm: 11
        }
      }
    }
  },
  3: {
    styles: {
      1: {
        grid: {
          type: "flex",
          justify: "space-between",
          gutter: 32,
          className: gridSquare31Cls
        },
        col: {
          xs: 24,
          sm: 8
        }
      },
      2: {
        grid: {
          type: "flex",
          justify: "space-around",
          className: gridSquare32Cls
        },
        col: {
          xs: 24,
          sm: 7
        }
      }
    }
  },
  4: {
    styles: {
      1: {
        grid: {
          type: "flex",
          justify: "space-between",
          gutter: 16,
          className: gridSquare41Cls
        },
        col: {
          xs: 24,
          sm: 12,
          md: 8,
          lg: 6
        }
      }
    }
  },
  5: {
    styles: {
      1: {
        grid: {
          type: "flex",
          justify: "space-between",
          gutter: 16,
          className: gridSquare51Cls
        },
        col: {
          xs: 24,
          sm: 12,
          md: 8,
          lg: 4
        }
      }
    }
  },
  6: {
    styles: {
      1: {
        grid: {
          type: "flex",
          justify: "start"
        },
        col: {
          xs: 12,
          sm: 4
        }
      }
    }
  },
  7: {
    styles: {
      1: {
        grid: {
          type: "flex",
          justify: "space-around",
          align: "middle",
          className: gridSquare71Cls
        },
        col: {
          xs: 8,
          md: 3
        }
      }
    }
  }
};
export {
  SETTINGS
};
